// Document Effects
export const documentEffects = {};
